"use client"

import { useRouter } from "next/navigation"
import LocalizedClientLink from "@modules/common/components/localized-client-link"

export default function CategoryHeader({
  categoryName,
  parents,
}: {
  categoryName: string
  parents: Array<{ id?: string; name: string; handle?: string }>
}) {
  const router = useRouter()

  const handleBack = () => {
    if (typeof window !== "undefined" && window.history.length > 1) {
      router.back()
    } else {
      router.push("/store")
    }
  }

  return (
    <div className="mb-6 flex flex-col gap-3">
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={handleBack}
          className="rounded-full border border-gray-200 px-3 py-1 text-xs uppercase tracking-widest"
        >
          Volver
        </button>
        <nav className="text-xs text-gray-500">
          <LocalizedClientLink href="/store" className="hover:text-gray-700">
            Tienda
          </LocalizedClientLink>
          {parents.map((parent) => (
            <span key={parent.id || parent.handle}>
              {" "}/{" "}
              <LocalizedClientLink
                href={`/categories/${parent.handle || parent.id}`}
                className="hover:text-gray-700"
              >
                {parent.name}
              </LocalizedClientLink>
            </span>
          ))}
          {" "}/ {categoryName}
        </nav>
      </div>
    </div>
  )
}
